const adaptOptions = (method, options) => options.map((option) => {
  let value = option.id;
  let label;

  switch (method) {
    case 'vehicleMake.find':
      label = option.make;
      break;
    case 'vehicleModel.find':
      label = option.model;
      break;
    case 'vehicleTrim.find':
      label = option.display;
      value = option.multiple ? `${option.id}|${option.size}` : option.id;
      break;
    case 'webMeasurement.findAspectRatio':
    case 'webMeasurement.findRimSize':
      label = option;
      value = option;
      break;
    default:
      label = option.name;
  }

  return {
    value,
    label,
  };
});

async function fetchOptions(method, params) {
  const searchParams = new URLSearchParams({ method, ...params }).toString();
  const response = await fetch(`/api/tire-finder/v2/options?${searchParams}`);

  const options = await response.json();

  return adaptOptions(method, options);
}

export async function getOptions({ method, params = {} }) {
  try {
    return fetchOptions(method, params);
  } catch (error) {
    console.error(error);

    // TODO: gracefully handle error states – this will result in no options,
    // which will appear broken on touch devices
    return [];
  }
}
